export default "__VITE_ASSET__C7ByyeW1__"